export const toLocaleString = (x) =>
  x || x === 0
    ? x.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "";

export const monthDiff = (d1x, d2x) => {
  var months;
  const d1 = new Date(d1x),
    d2 = new Date(new Date(d2x).getTime() + 1000 * 60 * 60 * 24);
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

export const dayDiff = (d1x, d2x) => {
  return (
    (new Date(d2x).getTime() - new Date(d1x).getTime()) / (1000 * 60 * 60 * 24)
  );
};

export const calcTotalOfList = (arr = [], keys = []) => {
  let res = {};
  for (let i = 0; i < arr.length; i++) {
    const el = arr[i];
    for (let j = 0; j < keys.length; j++) {
      const key = keys[j];
      res[key] = (res[key] || 0) + el[key];
    }
  }

  return res;
};

export function formatPhone(user) {
  const { countryCode, phone } = user || {};
  if (!countryCode || !phone) return "";

  const cc = String(countryCode).replace(/\D/g, "");
  let pn = String(phone).replace(/\D/g, "");

  // Indian format: 10 digits → 5 + 5 split
  if (pn.length === 10) {
    return `+${cc} ${pn.slice(0, 5)} ${pn.slice(5)}`;
  }

  // fallback for any other case
  return `+${cc} ${pn}`;
}

export const round2 = (n) => Math.round(n * 100) / 100;

export const dtFrmtS1 = (d) =>
  d &&
  new Date(d).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

export const getEndOfDay = (d) => {
  let date = new Date(d);
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999
  );
};
export const toDateInputValue = (date) => {
  if (!date) return "";
  const d = new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatDateRange = ([startDate, endDate]) => {
  const prevDate = startDate && new Date(startDate);
  const lastDate = endDate && new Date(endDate);

  const sameYear =
    prevDate && lastDate
      ? prevDate.getFullYear() === lastDate.getFullYear()
      : false;

  if (sameYear) {
    return `From ${formatDayMonth(prevDate)} to ${formatDayMonth(
      lastDate
    )} ${lastDate.getFullYear()}`;
  }

  return `From ${prevDate ? formatFullDate(prevDate) : " - "} to ${
    lastDate ? formatFullDate(lastDate) : " - "
  }`;
};

function formatFullDate(date) {
  return new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function formatDayMonth(date) {
  return new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
}
